import request from "@/utils/request"

/****************
 *    campagnes
 ****************/
export function getAllCampaigns(params = {}) {
  return request({
    url: "/api/campagnes",
    method: "get",
    params
  })
}

/**
 *
 * @param {Number} id - annonceur id
 */
export function getCampaignsAnnonceur(id) {
  return request({
    url: "/api/campagnes/annonceur/" + id,
    method: "get"
  })
}

/**
 *
 * @param {Number} id - campaign id to retrieve
 */
export function getCampaign(id) {
  return request({
    url: "/api/campagnes/" + id,
    method: "get"
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request data
 */
export function createCampaign(data, params = {}) {
  return request({
    url: "/api/campagnes",
    method: "post",
    params,
    data
  })
}

/** Modify the infos of a campaign
 * @param {Number} id - campaign id to update
 * @param {Object} params -
 * @param {Object} data -
 */
export function updateCampaign(id, params = {}, data) {
  if (!id && typeof id !== "number") {
    throw new Error("No campaign id was given.")
  }
  return request({
    url: "/api/campagnes/" + id,
    method: "put",
    data,
    params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

/**
 * @param {Number} id - campaign id to update
 * @param {Object} params - request params
 */
export function setPharmaciesCampaign(id, params = {}) {
  return request({
    url: "/api/campagne/" + id + "/pharmacies",
    method: "post",
    params
  })
}

/**
 *
 * @param {Number} id - campaign id to retrieve
 */
export function uploadCampaignCdc(id, data) {
  return request({
    url: "/api/campagne/" + id + "/cdc",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

/**
 *
 * @param {Number} id - campaign id to delete
 */
export function deleteCampaign(id) {
  return request({
    url: "/api/campagnes/" + id,
    method: "delete"
  })
}

/**
 * @param {Number} campaign_id - campaign id to update
 * @param {Object} params - request params
 */
export function answerCampaignRequest(campaign_id, params = {}) {
  return request({
    url: "/api/campagne/" + campaign_id + "/request/answer",
    method: "post",
    params
  })
}

/**
 * @param {Number} campaign_id - campaign id
 * @param {Object} params - request params
 */
export function getCampaignPharmacistInfos(campaign_id, params) {
  return request({
    url: "/api/campagne/" + campaign_id + "/pharmacist/supports",
    method: "get",
    params
  })
}

/**
 *
 * @param {Number} id - campaign id to
 */
export function getPharmaciesOfCampaign(id) {
  return request({
    url: "/api/campagne/" + id + "/pharmacies",
    method: "get"
  })
}

/**
 *
 * @param {Number} id - campaign id to
 */
export function getCampaignResponses(id) {
  return request({
    url: `/api/campagnes/${id}/responses`,
    method: "get"
  })
}
